import React, { Component } from 'react';
import { connect } from 'react-redux';
import IntlMessages from 'util/IntlMessages';
import { injectIntl, intlShape } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem, Button, Card, CardBody, CardHeader, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import ReportListItem from 'components/ReportListItem';
import Pagination from 'react-js-pagination';
import Maps from 'containers/Maps';
import geolib from 'geolib';
import { getMeldooWebSearchResults } from 'actions/MeldooWeb';
import _ from 'lodash';
import Moment from 'moment';

class SearchReport extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activePage: 1,
			reportIdSearchValue: '',
			typeSearchValue: '',
			statusSearchValue: '',
			sortBy: 'dateDown',
			mapKey: 0
		};
	}

	componentDidUpdate(prevProps) {
		if (prevProps.loading.searchResults && !this.props.loading.searchResults) this.setState({ mapKey: new Date().getTime() });
	}

	searchReports = () => {
		this.props.getMeldooWebSearchResults(this.props.organisationKey, {
			reportId: this.state.reportIdSearchValue,
			type: this.state.typeSearchValue,
			status: this.state.statusSearchValue
		});
	};

	sortResults = reports => {
		switch (this.state.sortBy) {
			case 'dateDown':
				return _.reverse(_.sortBy(reports, report => Moment(report.insertDate).unix()));
			case 'dateUp':
				return _.sortBy(reports, report => Moment(report.insertDate).unix());
			default:
				return reports;
		}
	};

	render() {
		const reports = this.props.searchResults.slice(0 + (this.state.activePage - 1) * 10, 10 + (this.state.activePage - 1) * 10);
		const { colors, types, organisationTypes } = this.props.settings;
		const { mapCenter, mapZoom } = this.props.settings.general;
		let center = mapCenter;
		if (this.props.searchResults.length > 0) {
			const centerResult = geolib.getCenter(
				this.props.searchResults.map(report => {
					return {
						latitude: report.latlng.lat,
						longitude: report.latlng.lng
					};
				})
			);
			center = { lat: parseFloat(centerResult.latitude), lng: parseFloat(centerResult.longitude) };
		}
		return (
			<div className="row">
				{this.props.settings.modules.reportCollection && (
					<div className="col-12 mb-3">
						<div>
							<Breadcrumb className="mb-0 navigation-style" tag="nav">
								<BreadcrumbItem
									tag="span"
									className="pointer"
									onClick={() => this.props.history.push(`/meldoo-web/${this.props.organisationKey}`)}
								>
									<IntlMessages id="meldooWeb.reportCollection.title" />
								</BreadcrumbItem>
								<BreadcrumbItem active tag="span">
									<IntlMessages id="meldooWeb.searchReport.title" />
								</BreadcrumbItem>
							</Breadcrumb>
						</div>
					</div>
				)}
				<div className="col-12  mb-3">
					<Card>
						<CardBody className="p-0">
							<Maps
								key={this.state.mapKey}
								center={center}
								data={this.props.searchResults}
								types={types}
								dimensions="21by9"
								zoom={mapZoom}
								onMarkerClick={
									this.props.settings.modules.reportDetails
										? reportId => this.props.history.push(`/meldoo-web/${this.props.organisationKey}/details/${reportId}`)
										: null
								}
							/>
						</CardBody>
					</Card>
				</div>
				<div className="col-12">
					<Card className="jr-card-full-height">
						<CardHeader style={{ backgroundColor: colors.main.bg, color: colors.main.font }}>
							<IntlMessages id="meldooWeb.searchReport.title" />
						</CardHeader>
						<CardBody>
							<div className="mb-4">
								<div className="form-group">
									<label form="reportSearch">
										<IntlMessages id="meldooWeb.searchReport.reportId.title" />
									</label>
									<input
										className="form-control form-control-lg"
										id="reportSearch"
										value={this.state.reportIdSearchValue}
										onChange={m =>
											this.setState({
												reportIdSearchValue: parseInt(m.target.value)
											})
										}
										type="number"
										placeholder={this.props.intl.formatMessage({
											id: 'meldooWeb.searchReport.reportId.placeholder'
										})}
									/>
								</div>
								<div className="form-group">
									<label htmlFor="typeSearch">
										<IntlMessages id="meldooWeb.searchReport.type.title" />
									</label>
									<select
										className="custom-select"
										id="typeSearch"
										onChange={m =>
											this.setState({
												typeSearchValue: m.target.value ? parseInt(m.target.value) : ''
											})
										}
										value={this.state.typeSearchValue}
									>
										<option value="">
											{this.props.intl.formatMessage({
												id: 'meldooWeb.searchReport.type.placeholder'
											})}
										</option>
										{organisationTypes.map(type => (
											<option key={type.id} value={type.id}>
												{type.name}
											</option>
										))}
									</select>
								</div>
								{
									// <div className="form-group">
									// 	<label htmlFor="statusSearch">
									// 		<IntlMessages id="meldooWeb.searchReport.status.title" />
									// 	</label>
									// 	<select
									// 		className="custom-select"
									// 		id="statusSearch"
									// 		onChange={m =>
									// 			this.setState({
									// 				statusSearchValue: m.target.value
									// 			})
									// 		}
									// 		value={this.state.statusSearchValue}
									// 	>
									// 		<option value="">
									// 			{this.props.intl.formatMessage({
									// 				id: 'meldooWeb.searchReport.status.placeholder'
									// 			})}
									// 		</option>
									// 		<option value="new">{this.props.intl.formatMessage({ id: 'meldooWeb.searchReport.status.new' })}</option>
									// 		<option value="inProcess">
									// 			{this.props.intl.formatMessage({
									// 				id: 'meldooWeb.searchReport.status.inProcess'
									// 			})}
									// 		</option>
									// 		<option value="completed">
									// 			{this.props.intl.formatMessage({
									// 				id: 'meldooWeb.searchReport.status.completed'
									// 			})}
									// 		</option>
									// 	</select>
									// </div>
								}
								<div className="d-flex w-100 justify-content-between">
									{
										// <div className="form-group mb-0">
										// 	<label htmlFor="sortBy">
										// 		<IntlMessages id="meldooWeb.searchReport.sortBy.title" />
										// 	</label>
										// 	<select
										// 		className="custom-select"
										// 		id="sortBy"
										// 		onChange={m =>
										// 			this.setState({
										// 				sortBy: m.target.value
										// 			})
										// 		}
										// 		value={this.state.sortBy}
										// 	>
										// 		<option value="dateDown">
										// 			{this.props.intl.formatMessage({
										// 				id: 'meldooWeb.searchReport.sortBy.dateDown'
										// 			})}
										// 		</option>
										// 		<option value="dateUp">
										// 			{this.props.intl.formatMessage({
										// 				id: 'meldooWeb.searchReport.sortBy.dateUp'
										// 			})}
										// 		</option>
										// 	</select>
										// </div>
									}

									<div className="d-flex align-items-end">
										<Button
											color="default"
											className="jr-btn jr-btn-default ml-auto mb-0"
											style={{ backgroundColor: colors.main.bg, color: colors.main.font }}
											onClick={this.searchReports}
											disabled={this.props.loading.searchResults}
										>
											<i className="zmdi zmdi-search zmdi-hc-lg" />
											<IntlMessages id="common.search" />
										</Button>
									</div>
								</div>
							</div>
							{reports.length === 0 ? (
								<h2 className="text-muted text-center pt-4">
									<IntlMessages id="meldooWeb.searchReport.noResults" />
								</h2>
							) : (
								<ul className="list-unstyled">
									{this.sortResults(reports).map((report, index) => (
										<ReportListItem
											key={index}
											data={report}
											modules={this.props.settings.modules}
											toReport={reportId =>
												this.props.history.push(`/meldoo-web/${this.props.organisationKey}/details/${reportId}`)
											}
										/>
									))}
								</ul>
							)}
							<Pagination
								activePage={this.state.activePage}
								itemsCountPerPage={10}
								totalItemsCount={this.props.searchResults.length || 1}
								pageRangeDisplayed={5}
								onChange={activePage => this.setState({ activePage })}
								innerClass="pagination justify-content-center my-3 my-sm-5"
								itemClass="page-item"
								linkClass="page-link"
								activeLinkClass="custom-accent"
							/>
						</CardBody>
					</Card>
				</div>
			</div>
		);
	}
}

SearchReport.propTypes = {
	intl: intlShape.isRequired
};

function mapStateToProps({ meldooWeb }) {
	const { searchResults, settings, loading } = meldooWeb;
	return { searchResults, settings, loading };
}

export default connect(
	mapStateToProps,
	{ getMeldooWebSearchResults }
)(injectIntl(withRouter(SearchReport)));



// WEBPACK FOOTER //
// ./containers/MeldooWeb/Pages/SearchReport/index.js